import React from 'react';

export default function SmallFeatureNano({ data, color }) {
    return (
        <div className="flex items-center gap-4 p-2 bg-zinc-50 border border-zinc-200 rounded-2xl hover:bg-white transition-all group">
            <div className="w-16 h-16 rounded-xl overflow-hidden shrink-0">
                <img src={data?.imagensDestaque?.[0] || data?.image} className="w-full h-full object-cover group-hover:scale-110 transition-transform" />
            </div>
            <div className="flex-1 min-w-0">
                <div className="text-[10px] font-black uppercase truncate text-zinc-900">{data?.titulo || data?.title}</div>
                <div className="text-xs font-black" style={{ color }}>{data?.price || data?.preco}</div>
            </div>
        </div>
    );
}